<template>
    <div>
        <b-toast id="toast-register" variant="none" no-close-button toaster="b-toaster-top-center">
            <img :src="imgMjeRegistro" style="margin-right: 10px; margin-top: -2px" />
            {{ messageRegister }}
        </b-toast>
        <b-breadcrumb>
            <b-breadcrumb-item active>{{$t('settings.timezone.title')}}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card card-body card-availability setting">
            <h6 class="sub-title mb-4">
                <span>{{$t('settings.timezone.subtitle')}}</span>
            </h6>
            <div class="filter-center flex-column col-8 m-auto" v-if="optionsTimeZone.length > 0">
               <CustomSelect class="lg"  value="valor"  @input="idSelected"  :options="optionsTimeZone"  label="descripcion" :default="dataField"  :firstOptionShow="false"/>
            </div>
            <div class="text-center mt-4">
                <button type="button" class="btn btn-primary mb-3 mt-1" @click="updateTimeZone"  :class="{ loading: isLoading }">{{$t('reusables.save')}} </button>
            </div>
        </div>
    </div>
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js'; 
import imgMjeExito from '@/assets/img/ico-check.png'
import imgMjeError from '@/assets/img/ico-equis.png'
import CustomSelect from "@/components/form/select";


import  {IanaTimeZonesDos}  from '@/assets/js/appConstants'; 

export default {
    components:{
        CustomSelect
    },
  data: function() {
    return {
        TIMEZONES:IanaTimeZonesDos,
        selected: this.$store.state.user.timeZoneName,
        optionsTimeZone: [],
        isLoading: false,
        messageRegister: "",
        imgMjeRegistro: imgMjeExito,
        dataField: '',
    };
  },
  mounted() {
      this.listTimeZones();
  },
  methods: {
    idSelected(event){
        this.selected = event
    },
    listTimeZones() {
        baseInstanceAxios
        .get(this.apiURL + `/Administration/TimeZone/List`)
        .then(response => {
            if (response.data != null && response.data.list ) {
                this.optionsTimeZone = response.data.list;
                this.dataField = this.optionsTimeZone.filter(o => o.valor == this.selected)[0].descripcion;
            }
        });
    },
    updateTimeZone(){
        let data = {
            id: this.$store.state.user.id,
            timeZoneName: this.selected
        };
        this.isLoading = true;

        baseInstanceAxios
            .post(this.apiURL + `/resources/Persons/UpdateTimeZone`, data)
            .then(response => {
                if (response.data != null && response.data.return) {

                    this.$store.state.user.timeZoneName = data.timeZoneName;
                    this.$store.commit("mutateUser", this.$store.state.user);		

                    this.messageRegister = 'Your timezone was updated.';
                    this.imgMjeRegistro = imgMjeExito;
                    this.$bvToast.show("toast-register");
                    
                }else{
                    this.messageRegister = this.$t('mjesRegistro.mjeActualizacionError');
                    this.imgMjeRegistro = imgMjeError;
                    this.$bvToast.show("toast-register");
                }
                this.isLoading = false;
            })
            .catch(error =>{
                console.log(error);
                this.messageRegister = this.$t('mjesRegistro.mjeActualizacionError');
                this.imgMjeRegistro = imgMjeError;
                this.$bvToast.show("toast-register");
                this.isLoading = false;
            });
    }
  }
};
</script>